import noop from 'lodash/noop';
import { createContext } from 'react';

import type { Analytics } from './types';

const defaultAnalytics = {
  identify: noop,
  register: noop,
  track: noop,
  trackPageView: noop,
  timeEvent: noop,
};

export const analyticsContext = createContext<Analytics>(defaultAnalytics);
export const { Provider } = analyticsContext;
